import { Link } from 'react-router-dom'
import { ROUTES } from '@/utils/constants'
import { useTranslation } from 'react-i18next'

interface PlanFeature {
  textKey: string
  comingSoon?: boolean
}

interface Plan {
  name: string
  durationKey: string
  descriptionKey?: string
  featured?: boolean
  comingSoon?: boolean
  features: PlanFeature[]
}

export function Pricing() {
  const { t } = useTranslation()

  const plans: Plan[] = [
    {
      name: 'Freemium',
      durationKey: 'landing.pricing.plans.freemium.duration',
      descriptionKey: 'landing.pricing.plans.freemium.description',
      features: [
        { textKey: 'landing.pricing.plans.freemium.features.test1' },
        { textKey: 'landing.pricing.plans.freemium.features.test2' },
        { textKey: 'landing.pricing.plans.freemium.features.dictionary' },
        { textKey: 'landing.pricing.plans.freemium.features.students' },
        { textKey: 'landing.pricing.plans.freemium.features.schedule' },
        { textKey: 'landing.pricing.plans.freemium.features.settings' },
      ],
    },
    {
      name: 'Standard',
      durationKey: 'landing.pricing.plans.standard.duration',
      featured: true,
      comingSoon: true,
      features: [
        { textKey: 'landing.pricing.plans.standard.features.test1', comingSoon: true },
        { textKey: 'landing.pricing.plans.standard.features.test2', comingSoon: true },
        { textKey: 'landing.pricing.plans.standard.features.test3', comingSoon: true },
        { textKey: 'landing.pricing.plans.standard.features.test4' },
        { textKey: 'landing.pricing.plans.standard.features.dictionary' },
        { textKey: 'landing.pricing.plans.standard.features.students' },
        { textKey: 'landing.pricing.plans.standard.features.schedule' },
        { textKey: 'landing.pricing.plans.standard.features.settings' },
        { textKey: 'landing.pricing.plans.standard.features.cards', comingSoon: true },
        { textKey: 'landing.pricing.plans.standard.features.accounting', comingSoon: true },
        { textKey: 'landing.pricing.plans.standard.features.program', comingSoon: true },
      ],
    },
    {
      name: 'Premium',
      durationKey: 'landing.pricing.plans.premium.duration',
      comingSoon: true,
      features: [
        { textKey: 'landing.pricing.plans.premium.features.test1', comingSoon: true },
        { textKey: 'landing.pricing.plans.premium.features.test2', comingSoon: true },
        { textKey: 'landing.pricing.plans.premium.features.test3', comingSoon: true },
        { textKey: 'landing.pricing.plans.premium.features.test4', comingSoon: true },
        { textKey: 'landing.pricing.plans.premium.features.test5' },
        { textKey: 'landing.pricing.plans.premium.features.dictionary' },
        { textKey: 'landing.pricing.plans.premium.features.students' },
        { textKey: 'landing.pricing.plans.premium.features.schedule' },
        { textKey: 'landing.pricing.plans.premium.features.settings' },
        { textKey: 'landing.pricing.plans.premium.features.accounting', comingSoon: true },
        { textKey: 'landing.pricing.plans.premium.features.program', comingSoon: true },
        { textKey: 'landing.pricing.plans.premium.features.tags', comingSoon: true },
        { textKey: 'landing.pricing.plans.premium.features.constructor', comingSoon: true },
        { textKey: 'landing.pricing.plans.premium.features.groups', comingSoon: true },
        { textKey: 'landing.pricing.plans.premium.features.games', comingSoon: true },
        { textKey: 'landing.pricing.plans.premium.features.theater', comingSoon: true },
        { textKey: 'landing.pricing.plans.premium.features.extension', comingSoon: true },
        { textKey: 'landing.pricing.plans.premium.features.calendar', comingSoon: true },
        { textKey: 'landing.pricing.plans.premium.features.chat', comingSoon: true },
      ],
    },
  ]

  return (
    <section className="pricing" id="pricing">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{t('landing.pricing.title')}</h2>
          <p className="section-subtitle">{t('landing.pricing.subtitle')}</p>
        </div>
        <div className="pricing-grid">
          {plans.map((plan, index) => (
            <div key={index} className={`pricing-card ${plan.featured ? 'featured' : ''}`}>
              <h3 className="plan-name">{plan.name}</h3>
              <div className="plan-duration">{t(plan.durationKey)}</div>
              {plan.descriptionKey && (
                <div className="plan-description">{t(plan.descriptionKey)}</div>
              )}
              {plan.comingSoon && (
                <div className="coming-soon-text">{t('landing.pricing.comingSoon')}</div>
              )}
              {!plan.comingSoon && (
                <Link to={ROUTES.REGISTER} className="btn-accent">
                  {t('landing.pricing.tryFree')}
                </Link>
              )}
              <ul className="plan-features">
                {plan.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className={feature.comingSoon ? 'coming-soon' : ''}>
                    {feature.comingSoon ? (
                      <span className="coming-soon">{t(feature.textKey)}</span>
                    ) : (
                      t(feature.textKey)
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
